<template>
  <BaseNoticeItem
    :button-text="$t('Answer questions')"
    :button-url="buttonUrl"
    :status="$t('Information missing')"
  >
    <template #head>
      <strong>{{ $t('Your default answers for Global Worker Classification') }}</strong>
    </template>
    <template #body>
      {{
        $t(
          'Your default answers to our questions related to Global Worker Classification will be applied to Worker Classification Recommendations (WCR) on new contracts in Worksome when applicable.',
        )
      }}
    </template>
  </BaseNoticeItem>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const { $t } = useTranslation()

const props = defineProps({
  freelancerId: {
    type: String,
    required: true,
  },
})

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(
    namedRoutes.determinations.edit,
    {
      determination: 'globalWorkerClassification',
      context: 'freelancer',
      id: props.freelancerId,
    },
    false,
  )
  return `${path}#account-setup`
})
</script>
